import styled from "styled-components";

export const Box = styled.div`
  .interDisplay {
    font-family: InterDisplay;
  }
  .defaultText {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
      Ubuntu, Cantarell, sans-serif;
  }
  @media (min-width: 1200px) and (max-width: 1400px) {
    & > div {
      & > div:nth-child(2) {
        display: flex;
        flex-direction: row !important; /* Force row layout */
        flex-wrap: nowrap !important; /* Prevent wrapping */
        gap: 1rem;
        & > div:first-child {
          flex: 0 0 500px; /* LeftSection fixed width */
          width: 500px;
        }
        & > div:last-child {
          flex: 1 1 auto; /* RightSection takes remaining space */
          min-width: 300px;
        }
      }
    }
  }
`;